import React, { useEffect, useState } from "react";

import { EvtSelect } from "components/select";
import { getItemsFromCollection } from "directus/src/operations";
import { useQuery } from "@tanstack/react-query";

const DepartmentInput = ({ value, onChange, className, ...props }) => {
  const [selectedDepartment, setSelectedDepartment] = useState("");

  useEffect(() => {
    if (value) {
      setSelectedDepartment(value);
    }
  }, [value]);

  const { data, isLoading } = useQuery({
    queryKey: [
      "departments",
      {
        fields: ["id", "name"],
      },
    ],
    queryFn: () => {
      return getItemsFromCollection("departments", {
        fields: ["id", "name"],
        sort: ["name"],
      });
    },
  });

  function handleChange(value) {
    setSelectedDepartment(value);
    onChange?.(value);
  }

  return (
    <EvtSelect
      value={selectedDepartment}
      onChange={handleChange}
      className={className}
      data={data}
      isLoading={isLoading}
      {...props}
    />
  );
};
DepartmentInput.displayName = "DepartmentInput";

export default DepartmentInput;
